import styled from "@emotion/styled"

const BetaFeaturesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  padding: 20px 22px 24px;
  border-radius: 24px;
  background: radial-gradient(
      circle at 8% -6%,
      rgba(59, 130, 246, 0.16) 0%,
      transparent 38%
    ),
    radial-gradient(
      circle at 100% 106%,
      rgba(168, 85, 247, 0.14) 0%,
      transparent 42%
    ),
    var(--cms-content-bg);

  .heading-copy {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .page-title {
    margin: 0;
    font-size: 30px;
    font-weight: 800;
    color: var(--cms-text-primary);
    letter-spacing: -0.01em;
  }

  .page-subtitle {
    margin: 0;
    color: var(--cms-text-secondary);
    font-size: 13px;
    font-weight: 500;
    max-width: 760px;
  }

  .save-btn {
    text-transform: none;
    font-weight: 700;
    border-radius: 10px;
    min-height: 40px;
    padding: 8px 16px;
    box-shadow: 0 12px 24px rgba(37, 99, 235, 0.24);
  }

  .page-surface {
    border: 1px solid var(--cms-border);
    border-radius: 18px;
    background: var(--cms-surface-secondary);
    box-shadow: 0 14px 30px rgba(15, 23, 42, 0.08);
    padding: 18px;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .page-empty {
    border: 1px dashed var(--cms-border);
    border-radius: 12px;
    background: var(--cms-surface-muted);
    padding: 26px 16px;
    text-align: center;
    color: var(--cms-text-secondary);
    font-weight: 600;
  }

  .surface-note {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    align-items: center;
    color: var(--cms-text-secondary);
    font-size: 13px;
  }

  .feature-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(310px, 1fr));
    gap: 14px;
  }

  .feature-card {
    border: 1px solid var(--cms-border);
    border-radius: 16px;
    background: var(--cms-surface-secondary);
    padding: 16px;
    box-shadow: 0 10px 24px rgba(15, 23, 42, 0.06);
    display: flex;
    flex-direction: column;
    gap: 14px;
  }

  .feature-card-header {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .feature-title-row {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 10px;
  }

  .feature-title {
    margin: 0;
    font-size: 17px;
    font-weight: 800;
    color: var(--cms-text-primary);
  }

  .feature-key {
    display: inline-flex;
    width: fit-content;
    padding: 4px 9px;
    border-radius: 999px;
    background: var(--cms-surface-muted);
    color: var(--cms-text-secondary);
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.03em;
  }

  .feature-description {
    margin: 0;
    color: var(--cms-text-secondary);
    font-size: 13px;
    line-height: 1.55;
  }

  .toggles {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding-top: 6px;
    border-top: 1px solid var(--cms-border);
  }

  .toggle-row {
    display: flex;
    justify-content: space-between;
    gap: 14px;
    align-items: center;
    padding: 10px 0;
  }

  .toggle-copy {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .toggle-label {
    font-size: 14px;
    font-weight: 700;
    color: var(--cms-text-primary);
  }

  .toggle-help {
    font-size: 12px;
    color: var(--cms-text-secondary);
    line-height: 1.45;
  }
`

export { BetaFeaturesWrapper }
